import WalletApiResponse from "../../assets/FallbackData/WalletApiResponse.json";
import LoyaltyApiResponse from "../../assets/FallbackData/LoyaltyApiResponse.json";
import SafeVal from "../../helpers/safeVal";
import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import {
  staticImgBaseUrl,
  themificationEnabled
} from "../../config/apiEndpoints";
import Utility from "../../helpers/utility";
import { updateAmplitudeUserProperties } from "../../helpers/events";

export default {
  namespaced: true,
  state: {
    loyalty: {},
    walletBalance: {},
    currentOrderType: "",
    isLoyaltyWidgetPresent: false,
    isLoading: true,
    enrollmentSuccess: false,
    isLoadingWidgetAPI: true,
    staticWidgetData: {},
    apiSuccess:false,
    festiveBanner:{}
  },
  getters: {
    getUserData: (state) => {
      let userData = LocalStorageFunc.getUserData()?.userData;
      if(userData && typeof(userData) === "string"){
       userData = Utility.decryptData(userData);
      }

      if (Object.keys(state.loyalty).length === 0) {
        return {
          rewardType: "",
          isEnrolled: "",
          LoyaltyStatus: "",
          firstName: userData?.firstName || "",
          lastName: userData?.lastName || "",
          boostWeekRes: {"order_away": "","multiplier": ""},
          rewardData: {},
        };
      }
      let isEnrolled =
        state.loyalty.enrollmentStatus == "ENROLLED" ? true : false;
      let LoyaltyStatus = state.loyalty.enrollmentStatus;
      let rewardType =
        state.loyalty.loyaltyCardCode == "PAYMENT"
          ? "PIZZAPAL"
          : state.loyalty.loyaltyCardCode == "POTP1" ||
            state.loyalty.loyaltyCardCode == "POTP2"
          ? "CHEESY"
          : "UNKNOWN";
      let boostWeekObj = (state.loyalty?.boostWeek) ? state.loyalty?.boostWeek: {};

      return {
        rewardType: rewardType,
        isEnrolled: isEnrolled,
        LoyaltyStatus:
          SafeVal(() => {
            if (rewardType == "CHEESY") {
              updateAmplitudeUserProperties({ "loyalty_status": LoyaltyStatus });
              return LoyaltyStatus;
            }
          }, 0),
        LoyaltyUser:
          SafeVal(() => {
            if (rewardType == "CHEESY") {
              updateAmplitudeUserProperties({ "loyalty_user": isEnrolled });
              return isEnrolled;
            }
          }, 0),
        firstName: userData?.firstName || "",
        lastName: userData?.lastName || "",
        boostWeekRes: boostWeekObj,
        rewardData: {
          points:
            isEnrolled &&
            SafeVal(() => {
              if (rewardType == "PIZZAPAL") {
                let item = state.walletBalance.wallet.data.filter(
                  (_) => _.type == "LOYALTY"
                );
                return item[0].amount;
              } else if (rewardType == "CHEESY") {
                let balancePts = state.walletBalance.loyaltyProgram.balance.overall.points;
                updateAmplitudeUserProperties({ "reward_points": balancePts });
                return balancePts;
              } else {
                return 0;
              }
            }, 0),
          maxPoints: SafeVal(() => {
            if (rewardType == "PIZZAPAL") {
              return 0;
            } else if (rewardType == "CHEESY") {
              return state.walletBalance.loyaltyProgram.programConfig
                .itemRedeemPoints;
            } else {
              return 0;
            }
          }, 0),
          elizibleForPizza:
            isEnrolled &&
            SafeVal(() => {
              if (rewardType == "PIZZAPAL") {
                return false;
              } else if (rewardType == "CHEESY") {
                return state.walletBalance.loyaltyProgram.balance.burnable
                  .freeItems;
              } else {
                return false;
              }
            }, 0),
          pointsPerOrder: 
            SafeVal(() => {
              if (rewardType == "CHEESY") {
                return state.loyalty.programConfig.earnPointsPerOrder;
              }
          }, 0),
          itemRedeemPoints: 
            SafeVal(() => {
              if (rewardType == "CHEESY") {
                return state.loyalty.programConfig.itemRedeemPoints;
              }
          }, 0),
        },

      };
    },
    getRewardIconPath: (state, getters) => {
      if (
        Object.keys(state.loyalty || {}).length === 0 ||
        Object.keys(state.walletBalance || {}).length === 0
      )
        return "";
      let userData = getters.getUserData;
      if (userData.rewardType == "CHEESY") {
        if(!themificationEnabled) {
          if (userData.rewardData.points > 0) {
            if (userData.rewardData.points >= userData.rewardData.maxPoints) {
              return `${staticImgBaseUrl}/images/global/rewards/header-cheesy-reward.png`;
            } else {
              return `${staticImgBaseUrl}/images/global/rewards/header-cheesy-reward-${Math.floor(
                userData.rewardData.points / (userData.rewardData.maxPoints / 6)
              )}.svg`;
            }
          } else {
            return `${staticImgBaseUrl}/images/global/rewards/header-cheesy-reward-0.svg`;
          }
        }
        else {
          if (userData.rewardData.points > 0) {
            if (userData.rewardData.points >= userData.rewardData.maxPoints) {
              return `${staticImgBaseUrl}/images/global/rewards/header-cheesy-reward.png`;
            } else {
              return `${staticImgBaseUrl}/images/global/rewards/header-cheesy-reward-dark-${Math.floor(
                userData.rewardData.points / (userData.rewardData.maxPoints / 6)
              )}.svg`;
            }
          } else {
            return `${staticImgBaseUrl}/images/global/rewards/header-cheesy-reward-dark-0.svg`;
          }
        }
      } else {
        return `${staticImgBaseUrl}/images/global/rewards/pizza-pals.svg`;
      }
    },
    getCheesyRewardIconPath: (state, getters) => {
      if (
        Object.keys(state.loyalty).length === 0 ||
        Object.keys(state.walletBalance).length === 0
      )
        return "";
      let userData = getters.getUserData;
      if (!userData.isEnrolled) {
        return `${staticImgBaseUrl}/images/global/rewards/cheesy-reward-un-enrolled.png`;
      }
      if (userData.rewardData.points >= userData.rewardData.maxPoints) {
        return `${staticImgBaseUrl}/images/global/free-pizza.png`;
      } else {
        return `${staticImgBaseUrl}/images/global/rewards/cheesy-widget-${Math.floor(
          userData.rewardData.points / (userData.rewardData.maxPoints / 6)
        )}.svg`;
      }
    },
    getRewardIconText: (state, getters) => {
      if (
        Object.keys(state.loyalty).length === 0 ||
        Object.keys(state.walletBalance).length === 0
      )
        return "";
      let userData = getters.getUserData;
      if (userData.rewardType == "CHEESY") {
        if (userData.rewardData.points > 0) {
          if (userData.rewardData.points >= userData.rewardData.maxPoints) {
            return "REDEEM \nPIZZA";
          } else {
            return `<span>${userData.rewardData.points}</span>/${userData.rewardData.maxPoints}`;
          }
        } else {
          if (userData.isEnrolled) {
            return `<span>${0}</span>/${
              userData.rewardData.maxPoints
            }`;
          } else {
            return "CHEESY \nREWARDS";
          }
        }
      } else {
        if (userData.rewardData.points > 0) {
          return `<span>${userData.rewardData.points}</span>\nPoints`;
        } else {
          return "PIZZA \nPALS";
        }
      }
    },
  },
  mutations: {
    updateLoyalty(state, payload) {
      state.loyalty = payload;
      LocalStorageFunc.updateLoyaltyInfo = payload;
    },
    updateWalletBalance(state, payload) {
      state.walletBalance = payload;
    },
    loadCurrentOrderType(state, payload) {
      let currentOrderType = LocalStorageFunc.getDeliveryType();
      if (currentOrderType) {
        state.currentOrderType =
          currentOrderType == "T" ? "P" : currentOrderType;
      }
    },
    updateLoyaltyFreqWidgetStatus(state, payload) {
      state.isLoyaltyWidgetPresent = payload;
    },
    updateIsLoading(state, payload) {
      state.isLoading = payload;
    },
    updateEnrollmentSuccess(state, payload) {
      state.enrollmentSuccess = payload;
      state.loyalty.enrollmentStatus == "ENROLLED";
    },
    updateStaticWidgetData(state, payload) {
      state.staticWidgetData =payload?.response || {}; 
    },
    setIsLoadingStaticWidgetApi(state, payload) {
      state.isLoadingWidgetAPI = payload;
    },
    setIsSuccessStaticWidgetApi(state, payload) {
      state.apiSuccess = payload;  
    },
  },
  actions: {
    loyaltyApi({ commit, rootGetters }, payload) {
      ApiCalls.USER_LOYALTY_API({
        headers: Headers(),
        payload: {},
      })
        .then(function (response) {
          if (response?.data) {
            commit("updateLoyalty", response.data);
          }
        })
        .catch(function (error) {
          commit("updateLoyalty", {});
        });
    },
    walletBalanceApi({ commit, rootGetters }, payload) {
      ApiCalls.WALLET_BALANCE_API({
        headers: Headers(),
        payload: {},
      })
        .then(function (response) {
          commit("updateWalletBalance", response.data);
        })
        .catch(function (error) {
          /* commit("updateWalletBalance", WalletApiResponse["PIZZAPAL"]); */
        });
    },
    loyaltyRegisterApi({ commit, rootGetters }, payload) {
      const utmAttributes = {
        utm_source: '',
        utm_medium: '',
        utm_campaign: ''
      };
      const { utm_source, utm_medium, utm_campaign } = LocalStorageFunc.getUtmAttributes() || utmAttributes;
      let utmAttrs = "";
      if (utm_source || utm_medium || utm_campaign) {
        utmAttrs = `${utm_source}-${utm_medium}-${utm_campaign} `;
      }
      
      ApiCalls.REGISTER_LOYALTY_API({
        headers: { 
          ...Headers(), 
          mobile: payload.mobile,
          utm_source: utmAttrs
        },
        payload: {loyaltyCardCode: payload.loyaltyCardCode},
      })
        .then(function (response) {
          if (response?.data) {
            console.log("register loyalty response==>", response);
            if(response?.data?.enrollmentStatus == 'ENROLLED') {
              commit("updateEnrollmentSuccess", true);
            } else {
              commit("updateEnrollmentSuccess", false);
            }
          }
        })
        .catch(function (error) {
          commit("updateEnrollmentSuccess", false);
        })
        .finally(function() {
          commit("updateIsLoading", false);
        });
    },
    staticWidgetApi({ commit, rootGetters ,state }, payload) {
      if(!state.apiSuccess){
        commit("setIsLoadingStaticWidgetApi", true);
        ApiCalls.STATIC_WIDGET_API({
          headers: Headers(),
          payload: payload,
        })
        .then(function (response) {
          if(response?.data) {
            commit("updateStaticWidgetData", {
              "response" : response?.data,
            });
            commit("updateLoyaltyFreqWidgetStatus", true);//----ask
            commit("setIsSuccessStaticWidgetApi" ,true);
          }
        })
        .catch(function (error) {
          commit("setIsSuccessStaticWidgetApi" ,false);
        })
        .finally(function() {
          commit("setIsLoadingStaticWidgetApi", false);
        })
      }
    },
    getFestiveLottie({commit, state}, payload) {
      const {type = null , lottieUrl = null} = payload ;
      if(!type || !lottieUrl){
        return;
      }

      ApiCalls.GET_LOTTIE_DATA({
        headers: Headers(),
        payload: lottieUrl
      })
      .then((res) => {
        if(res?.data) {
          state.festiveBanner = {
            ...state.festiveBanner ,
            [type] : res.data
          };
        }
      }).catch(err => {
        console.log("error in getting lottie - ",type, err);
      })
    },
  },
};
